import styled from 'styled-components';

export const StyledDialogContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 760px;
`;

// Blocks input and shows a spinner while the saved exception is being fetched.
export const StyledBusyOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.neutral['000']}cc;
`;

export const StyledDialogFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  padding-bottom: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.neutral[100]};
`;

export const StyledProgramName = styled.div`
  font-size: 14px;
  display: flex;
  gap: 8px;
  align-items: baseline;

  .label {
    color: ${({ theme }) => theme.colors.neutral[500]};
  }
  .value {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.neutral[800]};
  }
`;

export const StyledMetaRow = styled.div`
  display: flex;
  gap: 32px;
  font-size: 13px;
  padding-top: 8px;

  .label {
    color: ${({ theme }) => theme.colors.neutral[500]};
    margin-right: 6px;
  }
  .value {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.neutral[800]};
  }
`;

export const StyledValueFlagAnchor = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  .exception-flag {
    position: absolute;
    left: 0;
    display: inline-flex;
    align-items: center;
  }
`;

export const StyledInputFlagAnchor = styled.div`
  position: relative;
  display: grid;
  width: 100%;

  .exception-flag {
    position: absolute;
    right: calc(100% + 8px);
    align-self: center;
    display: inline-flex;
    align-items: center;
  }
`;
